import { Redirect, withRouter } from "react-router-dom";

const Logout = () => {
    sessionStorage.clear();
    return <Redirect to="/login" />
};

export default withRouter(Logout);